import * as React from 'react';

const Callback = () => (
  <div className="oidc-callback">
    <div className="oidc-callback__container">
      <h1 className="oidc-callback__title">Authentification terminée</h1>
      <p className="oidc-callback__content">Vous allez être redirigé sur votre application.</p>
    </div>
  </div>
);

export default Callback;
